import { render, staticRenderFns } from "./BrandForm.vue?vue&type=template&id=0ac0665c&scoped=true"
import script from "./BrandForm.vue?vue&type=script&lang=js"
export * from "./BrandForm.vue?vue&type=script&lang=js"
import style0 from "./BrandForm.vue?vue&type=style&index=0&id=0ac0665c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0665c",
  null
  
)

export default component.exports